export default __webpack_public_path__ + "static/media/play.0e2682cb.svg";